import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import vuetify from './plugins/vuetify'
import Dialog from 'vue-dialog-loading'
import OtpInput from '@bachdgvn/vue-otp-input'
import VueOtp2 from 'vue-otp-2'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs'
import AudioVisual from 'vue-audio-visual'
import { i18n } from './plugins/i18n.js';
import { datadogRum } from '@datadog/browser-rum';

if (process.env.VUE_APP_MONITORING_ZONE !== 'local') {
  let backend_endpoint = `${process.env.VUE_APP_API}/api/lv1/`
  datadogRum.init({
    applicationId: '9b7b5d8b-c89b-461a-b640-25918f6633e6',
    clientToken: 'pubbaecaec6a87565aff3959ca4fab09b40',
    site: 'datadoghq.com',
    service: process.env.VUE_APP_MONITORING_ZONE,
    env: process.env.VUE_APP_MONITORING,
    version: process.env.VUE_APP_VERSION_NUMBER,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    allowedTracingUrls: [backend_endpoint],
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording()
}

// Create script tag
const script = document.createElement('script')
script.async = true
script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GTAG}`
document.head.appendChild(script)

// Initialize gtag
window.dataLayer = window.dataLayer || []
function gtag(){ window.dataLayer.push(arguments) }
window.gtag = gtag

gtag('js', new Date())
gtag('config', `${process.env.VUE_APP_GTAG}`)

Vue.use(VueCryptojs)

Vue.use(VueCookies)

Vue.use(VueOtp2)

Vue.use(AudioVisual)

Vue.component('v-otpinput', OtpInput)

// const otpToken =
//   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvbmVjb25mZXJlbmNlIiwibmFtZSI6Im9uZWNvbmZlcmVuY2VAaW5ldCEiLCJpYXQiOjE1MTYyMzkwMjJ9.76dYYbFS1Hlv9vfu2hZ31a3qwA4p_5jYuLqYiBiHPmw'

axios.interceptors.request.use(async config => {
  const token = localStorage.getItem('user-token')
  const sharedtoken = localStorage.getItem('sharetoken')
  const accessToken = localStorage.getItem('access-token')
  if (!config.url.includes('loginoneid')) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + token
    }
  if (config.url.includes('/api/lv1/auth/refreshtoken')) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + token
    }
  } else if (
    config.url.includes('/api/v1/oneconf/service/checkroom') ||
    config.url.includes('/api/v1/oneconf/service/joinroom') ||
    config.url.includes('/api/v1/oneconf/service/createsession') ||
    config.url.includes('/backend/api/v1/member/join') ||
    config.url.includes('/backend/api/v1/rooms')
  ) {
    } else if(
    config.url.includes(process.env.VUE_APP_PLATFORM_DYNAMIC_LINK + "/api/v2/service/create-conference-open-app")
  ) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + process.env.VUE_APP_PLATFORM
    }
    // console.log(process.env.VUE_APP_PLATFORM);
    // console.log(config);
  } else if (
    config.url.includes('/api/auth/sharedtoken')
  ) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + sharedtoken
    }
  } else if (
    config.url.includes('/api/v2/service/shared-token')
  ) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + accessToken
    }
    } else if (token) {
    var jwt = require('jsonwebtoken')
    const jwtToken = Vue.CryptoJS.AES.decrypt(
      token,
      process.env.VUE_APP_SECRET_KEY
    ).toString(Vue.CryptoJS.enc.Utf8)

    var jwtDecode = jwtToken.replace(/"/g, '')

    var dataToken = jwt.decode(jwtDecode)
    // console.log(dataToken)
    var dateNow = Math.floor(Date.now() / 1000)
    // console.log(dateNow)
    // var date2 = Math.floor(new Date(2021, 5, 1, 17, 38, 0) / 1000)
    // console.log(date2)
    // console.log('jwtToken', jwtToken)
    // console.log('type', typeof jwtToken)
    // console.log('exp1: ', dataToken.exp)
    // console.log('exp2: ', date2)
    var condition = dataToken.exp - dateNow
    // var condition = date2 - dateNow
    if (condition < 0) {
      condition *= -1
    }
    // console.log('ผลต่าง', condition)
    if (condition <= 3600) {
      // if (dateNow > dataToken.exp) {
      // Vue.$cookies.remove('user-token')
      // localStorage.removeItem('user-token')
      // Vue.swal('WARNING !', 'Token expired, please sign in', 'warning')
      // window.location.href = '/'
      // console.log('expired')
      axios
        .get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken')
        .then(res => {
          // console.log('token', res.data.token)
          // localStorage.setItem('user-token', res.data.token)
          config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + res.data.token
          }
        })
        .catch(e => {
          console.log('refreshToken: ', e.message)
          Vue.swal.fire({
            title: this.$t("message.Sessiontimeout"),
            text: '',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          })
            .then(result => {
              if (result.value) {
                localStorage.clear()
                localStorage.setItem("lang", "th")
                window.open('/', '_self')
              }
            })
        })
    } else {
      config.headers = {
        ...config.headers,
        Authorization: 'Bearer ' + token
      }
    }
    // config.headers = {
    //   ...config.headers,
    //   Authorization: 'Bearer ' + token
    // }
    }
  }
  return config
})

Vue.use(Dialog, {
  dialogBtnColor: '#0f0'
})
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(Vuex)

Vue.prototype.eventBus = new Vue()

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
